import { render, staticRenderFns } from "./GeneralCard.vue?vue&type=template&id=e7ce6446&scoped=true"
import script from "./GeneralCard.vue?vue&type=script&lang=js"
export * from "./GeneralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ce6446",
  null
  
)

export default component.exports